import React, { useEffect, useRef, useState } from 'react'
import Modal from 'react-modal'
import { get } from 'lodash'
import api, { customPhotoUploadApi } from '../../../api'
import { useSelector } from 'react-redux'
import { ErrorModal } from '../index'
import { message, Input, Button as AntButton } from 'antd'
import { formatPhoneNumber } from '../../../lib/FormatPhoneNumber'
import { FaTrash } from 'react-icons/fa'

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		height: '90%',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		borderRadius: 15,
		border: 'none',
		overflowX: 'auto',
	},
	overlay: {
		background: '#00000099',
	},
}
const CustomInput = ({ type, value, onChange, placeholder, onBlur }) => {
	return (
		<>
			<input
				type={type}
				className={`border-[1px] border-[#DFE2E9] p-2 rounded-md w-full ${type === 'number' ? 'no-spinner' : ''}`}
				value={value}
				onChange={onChange}
				placeholder={placeholder}
				onBlur={onBlur}
			/>

			<style jsx>{`
				.no-spinner {
					-moz-appearance: textfield;
				}
				.no-spinner::-webkit-outer-spin-button,
				.no-spinner::-webkit-inner-spin-button {
					-webkit-appearance: none;
					margin: 0;
				}
			`}</style>
		</>
	)
}

const CreateUser = ({ getRef = () => {}, onClose = () => {} }) => {
	const { getMe } = useSelector((state) => state.main)
	const errorModalRef = useRef()

	const [isOpenModal, setIsOpenModal] = useState(false)
	const [workplace, setWorkplace] = useState('')
	const [cardCode, setCardCode] = useState('')
	const [phoneNumberArray, setPhoneNumberArray] = useState([''])
	const [male, setMale] = useState('')
	const [userName, setUserName] = useState('')
	const [userSureName, setUserSureName] = useState('')
	const [userFathersName, setUserFathersName] = useState('')
	const [loading, setLoading] = useState(false)
	const [comment2, setComment2] = useState('')
	const [U_Score, setU_Score] = useState('')
	const [katm, setKatm] = useState('')
	const [mib, setMib] = useState('')
	const [nasiya, setNasiya] = useState('')
	const [imageList, setImageList] = useState([
		{ file: null, path: '', imgLoading: false },
	])
	const [comment, setComment] = useState('')
	const [regions, setRegions] = useState([])
	const [cities, setCities] = useState([])
	const [districts, setDistricts] = useState([])
	const [selectedRegion, setSelectedRegion] = useState({
		Code: '',
		Name: '',
	})
	const [selectedCity, setSelectedCity] = useState({
		Code: '',
		Name: '',
		U_RegionCode: '',
	})
	const [addresses, setAddresses] = useState([
		{
			region: '',
			district: '',
			village: '',
			U_Street: '',
			U_HouseNumber: '',
			passportAdress: '',
			liveAdress: '',
			U_Apartment: '',
		},
	])
	const [isClientCreating, setIsClientCreating] = useState(false)
	const [doesUserExist, setDoesUserExist] = useState(false)

	const resetForm = () => {
		setWorkplace('')
		setMale('')
		setUserName('')
		setUserSureName('')
		setUserFathersName('')
		setU_Score('')
		setKatm('')
		setMib('')
		setNasiya('')
		setComment('')
		setAddresses([
			{
				region: '',
				district: '',
				village: '',
				U_Street: '',
				U_HouseNumber: '',
				passportAdress: '',
				liveAdress: '',
				U_Apartment: '',
			},
		])
		setImageList([{ file: null, path: '', imgLoading: false }])
	}

	useEffect(() => {
		const ref = {
			open: () => {
				resetForm()
				setIsOpenModal(true)
			},
			close: () => setIsOpenModal(false),
		}
		getRef(ref)
	}, [])

	const removeAddress = (index) => {
		const newAddresses = addresses.filter((_, i) => i !== index)
		setAddresses(newAddresses)
	}
	const addAddress = () => {
		setAddresses([
			...addresses,
			{
				region: '',
				district: '',
				village: '',
				U_Street: '',
				U_HouseNumber: '',
				passportAdress: '',
				liveAdress: '',
				U_Apartment: '',
			},
		])
	}

	const handleFileChange = (event, index) => {
		const updatedImageList = [...imageList]
		updatedImageList[index].file = event.target.files[0]
		setImageList(updatedImageList)
	}

	const uploadImg = async (index) => {
		const image = imageList[index]

		if (!image.file) {
			message.error('Фотография не выбрано')
			return
		}

		const formData = new FormData()
		formData.append('file', image.file)

		const generateRandomKey = () => {
			const characters =
				'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
			let randomKey = ''
			for (let i = 0; i < 16; i++) {
				randomKey += characters.charAt(
					Math.floor(Math.random() * characters.length),
				)
			}
			return randomKey
		}

		const randomKey = generateRandomKey()
		const title = 'YourTitle' // Replace with actual title

		formData.append('Title', title)
		formData.append('Key', randomKey)

		try {
			const updatedImageList = [...imageList]
			updatedImageList[index].imgLoading = true
			setImageList(updatedImageList)

			const res = await customPhotoUploadApi.post('assets/upload', formData, {
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			})

			const { key } = res.data
			updatedImageList[index].path = key
			setImageList(updatedImageList)

			message.success('Успешно загружено!')
		} catch (err) {
			message.error('Ошибка загрузки')
		} finally {
			const updatedImageList = [...imageList]
			updatedImageList[index].imgLoading = false
			setImageList(updatedImageList)
		}
	}

	const viewImage = async (index) => {
		const image = imageList[index]

		try {
			const res = await customPhotoUploadApi.get(
				`assets/download/${image.path}`,
				{
					responseType: 'blob',
				},
			)

			const url = window.URL.createObjectURL(
				new Blob([res.data], {
					type: 'image/png',
				}),
			)

			const link = document.createElement('a')
			link.href = url
			link.setAttribute('download', 'BP.png')
			document.body.appendChild(link)
			link.click()

			document.body.removeChild(link)
			window.URL.revokeObjectURL(url)
		} catch (error) {
			message.error('Ошибка загрузки файла')
		}
	}

	const addNewRow = () => {
		setImageList([...imageList, { file: null, path: '', imgLoading: false }])
	}
	const deleteRow = (index) => {
		setImageList(imageList.filter((_, i) => i !== index))
	}

	const createUserF = () => {
		const photoId = imageList
			.map((image) => image.path)
			.filter(Boolean)
			.join(',')

		const phoneNumbers = phoneNumberArray
			.filter((num) => num)
			.map((num) => num.replace(/\s+/g, ''))
			.join(',')

		setLoading(true)

		const data = {
			SalesPersonCode: getMe.SalesPersonCode || -1,
			U_workplace: workplace,
			CardCode: Number(cardCode),
			CardName: `${userSureName} ${userName} ${userFathersName}`,
			CardType: 'cCustomer',
			GroupCode: 100,
			Currency: '##',
			U_Gender: male,
			Valid: 'tYES',
			Frozen: 'tNO',
			U_Created: get(getMe, 'EmployeeID', ''),
			U_PhotoId: photoId,
			FreeText: comment,
			U_Comment: comment2,
			U_Telephone: phoneNumbers,
			BPAddresses: addresses.map((address, idx) => ({
				AddressName: idx + 1,
				U_CityCode:
					typeof address.U_CityCode === 'number'
						? address.U_CityCode
						: Number(address.U_CityCode?.split(' - ')[1]),
				U_DistrictCode:
					typeof address.U_DistrictCode === 'number'
						? address.U_DistrictCode
						: Number(address.U_DistrictCode?.split(' - ')[1]),
				U_RegionCode:
					typeof address.U_RegionCode === 'number'
						? address.U_RegionCode
						: Number(address.U_RegionCode?.split(' - ')[1]),
				BuildingFloorRoom: address.U_HouseNumber,
				StreetNo: address.U_Street,
				U_Apartment: address.U_Apartment,
			})),
		}

		setIsClientCreating(true)
		api
			.post(`BusinessPartners`, {
				...data,
			})
			.then(() => {
				resetForm()
				setCardCode('')
				setComment2('')
				setPhoneNumberArray([''])
				setIsOpenModal(false)
				message.success('Клиент успешно создан')
			})
			.catch((err) => {
				errorModalRef.current?.open(JSON.parse(err.response.data).error.message)
			})
			.finally(() => {
				setIsClientCreating(false)
				setLoading(false)
			})
	}

	const handleAddressChange = (index, field, value) => {
		const newAddresses = addresses.map((address, i) => {
			if (i === index) {
				return { ...address, [field]: value }
			}
			return address
		})
		setAddresses(newAddresses)
	}

	useEffect(() => {
		api.get('U_ADDRESS_REGION').then((res) => {
			const result = JSON.parse(res.data).value
			setRegions(result)
		})
	}, [])

	useEffect(() => {
		if (selectedRegion.Code) {
			api
				.get(
					`U_ADDRESS_CITY?$filter=U_RegionCode eq '${selectedRegion.Code}'`,
					{
						headers: {
							Prefer: 'odata.maxpagesize=100',
						},
					},
				)
				.then((res) => {
					const result = JSON.parse(res.data).value
					setCities(result)
				})
		}
	}, [selectedRegion])

	useEffect(() => {
		if (selectedCity.Code) {
			api
				.get(
					`U_ADDRESS_DISCRTICT?$filter=U_CityCode eq '${selectedCity.Code}'`,
					{
						headers: {
							Prefer: 'odata.maxpagesize=100',
						},
					},
				)
				.then((res) => {
					const result = JSON.parse(res.data).value
					setDistricts(result)
				})
		}
	}, [selectedCity])

	const handleAddPhoneNumber = () => {
		setPhoneNumberArray((prev) => [...prev, ''])
	}
	const handleRemovePhoneNumber = (index) => {
		const updatedPhoneNumbers = phoneNumberArray.filter((_, i) => i !== index)
		setPhoneNumberArray(updatedPhoneNumbers)
	}

	const checkClient = () => {
		if (cardCode.length) {
			setDoesUserExist(false)
			api
				.get(`BusinessPartners?$filter=CardCode eq '${cardCode}'`)
				.then((res) => {
					const user = JSON.parse(res.data).value
					if (user.length) {
						setDoesUserExist(true)
					} else {
						setDoesUserExist(false)
					}
				})
				.catch((err) => {
					errorModalRef.current?.open(
						JSON.parse(err.response.data).error.message,
					)
				})
		}
	}

	return (
		<Modal
			isOpen={isOpenModal}
			onRequestClose={() => setIsOpenModal(false)}
			style={customStyles}
			contentLabel="Create User Modal"
			ariaHideApp={false}
			shouldFocusAfterRender={false}
		>
			<div className="flex flex-col gap-5 w-[700px] p-8">
				<div className="flex flex-col gap-5">
					<p className="text-xl text-center font-bold text-blue-900">
						Создать клиента
					</p>
					<div className="grid grid-cols-3 gap-2">
						<CustomInput
							type="text"
							value={userSureName}
							onChange={(e) => setUserSureName(e.target.value)}
							placeholder="Фамилия"
						/>
						<CustomInput
							type="text"
							value={userName}
							onChange={(e) => setUserName(e.target.value)}
							placeholder="Имя"
						/>
						<CustomInput
							type="text"
							value={userFathersName}
							onChange={(e) => setUserFathersName(e.target.value)}
							placeholder="Отчество"
						/>
					</div>
					<div className="w-full bg-black h-[1px] mt-2" />
				</div>
				<div className="flex flex-col gap-5">
					{addresses.map((address, index) => (
						<div key={index} className="flex flex-col gap-5 mb-4">
							<p className="text-lg text-center font-bold text-black">
								{addresses.length === 1 ? 'Адрес прописки' : 'Адрес проживание'}
							</p>
							<div className="grid grid-cols-3 gap-2">
								<div className="flex  flex-col gap-2 items-start w-full">
									<input
										type="text"
										placeholder="Область"
										list="region"
										onChange={(v) => {
											setSelectedRegion({
												Code: v.target.value.split(' - ')[1],
												Name: v.target.value.split(' - ')[0],
											})

											handleAddressChange(index, 'U_RegionCode', v.target.value)
										}}
										className={
											'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
										}
									/>
									<datalist id="region">
										{regions.map((v, i) => (
											<option key={i} value={`${v.Name} - ${v.Code}`} />
										))}
									</datalist>
								</div>
								<div className="flex  flex-col gap-2 items-start w-full">
									<input
										type="text"
										placeholder="Город | Район"
										list="village"
										onChange={(v) => {
											setSelectedCity({
												Code: v.target.value.split(' - ')[1],
												Name: v.target.value.split(' - ')[0],
												U_RegionCode: selectedRegion.Code,
											})
											handleAddressChange(index, 'U_CityCode', v.target.value)
										}}
										className={
											'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
										}
									/>
									<datalist id="village">
										{cities.map((v, i) => (
											<option key={i} value={`${v.Name} - ${v.Code}`} />
										))}
									</datalist>
								</div>
								<div className="flex  flex-col gap-2 items-start w-full">
									<input
										type="text"
										placeholder="QFY | MFY"
										list="district"
										onChange={(v) => {
											handleAddressChange(
												index,
												'U_DistrictCode',
												v.target.value,
											)
										}}
										className={
											'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full'
										}
									/>
									<datalist id="district">
										{districts.map((v, i) => (
											<option key={i} value={`${v.Name} - ${v.Code}`} />
										))}
									</datalist>
								</div>
								<CustomInput
									value={address.U_Street}
									type="text"
									placeholder="Название улицы"
									onChange={(e) => {
										handleAddressChange(index, 'U_Street', e.target.value)
									}}
								/>
								<CustomInput
									value={address.U_HouseNumber}
									type="text"
									placeholder="Номер дома"
									onChange={(e) => {
										handleAddressChange(index, 'U_HouseNumber', e.target.value)
									}}
								/>
								<CustomInput
									value={address.U_Apartment}
									type="text"
									placeholder="Номер квартиры"
									onChange={(e) => {
										handleAddressChange(index, 'U_Apartment', e.target.value)
									}}
								/>
							</div>
							{index !== 0 && (
								<button
									onClick={() => removeAddress(index)}
									className="mt-2 bg-red-500 text-white p-2 rounded-md"
								>
									Возврат адреса
								</button>
							)}
							{addresses.length !== index + 1 && (
								<div className="w-full bg-black h-[1px]" />
							)}
						</div>
					))}
					<div className="flex justify-center">
						<button
							onClick={addAddress}
							className="bg-blue-500 text-white p-2 rounded-md w-fit"
						>
							Добавить новый адрес
						</button>
					</div>
				</div>

				<div className="flex flex-col gap-2">
					<div>
						<CustomInput
							value={cardCode}
							onChange={(e) => {
								if (e.target.value.length <= 100) {
									setCardCode(e.target.value)
								}
							}}
							onBlur={() => checkClient()}
							type="number"
							placeholder="ПИНФЛ"
						/>
						{doesUserExist && (
							<p className="text-red-500 font-semibold text-lg">
								Клиент уже существует
							</p>
						)}
					</div>
					{phoneNumberArray.length &&
						phoneNumberArray.map((phone, index) => (
							<div
								className="flex flex-row gap-2 items-start justify-between"
								key={index}
							>
								<CustomInput
									value={phone}
									onChange={(e) => {
										const rawValue = e.target.value.replace(/\D/g, '')
										if (rawValue.length <= 12) {
											const formattedValue =
												index === 4
													? `+${rawValue}`
													: formatPhoneNumber(rawValue)
											const updatedPhoneNumbers = [...phoneNumberArray]
											updatedPhoneNumbers[index] = formattedValue
											setPhoneNumberArray(updatedPhoneNumbers)
										}
									}}
									type="tel"
									placeholder="Телефон номер"
								/>
								{index === phoneNumberArray.length - 1 && (
									<AntButton
										onClick={handleAddPhoneNumber}
										className="h-10 w-fit rounded-lg bg-[#0A4D68] text-white"
									>
										+
									</AntButton>
								)}
								{phoneNumberArray.length > 1 && (
									<AntButton
										onClick={() => handleRemovePhoneNumber(index)}
										className="h-10 w-fit rounded-lg bg-red-500 text-white"
									>
										<FaTrash />
									</AntButton>
								)}
							</div>
						))}
					<textarea
						placeholder="Комментарий"
						className={'border-[1px] border-[#DFE2E9"] p-2 rounded-md w-full '}
						value={comment2}
						onChange={(v) => setComment2(v.target.value)}
					/>
					<div className="flex gap-4 justify-center mt-2">
						<div className="flex gap-1 items-center">
							<input
								type="radio"
								id="male"
								name="fav_language"
								value="Male"
								onChange={(v) => setMale(v.target.value)}
							/>
							<label htmlFor="male">Мужчина</label>
						</div>
						<div className="flex gap-1 items-center">
							<input
								type="radio"
								id="female"
								name="fav_language"
								value="Female"
								onChange={(v) => setMale(v.target.value)}
							/>
							<label htmlFor="female">Женщина</label>
						</div>
					</div>
				</div>

				<div>
					{imageList.map((image, index) => (
						<div
							key={index}
							className="flex flex-col w-full items-start gap-2 mt-5 mb-7 sm:mb-10"
						>
							<div>
								<p className="font-bold">Фото-{index + 1}</p>
							</div>
							<div className="flex flex-col sm:flex-row items-center gap-3 w-full">
								<Input
									type="file"
									onChange={(e) => handleFileChange(e, index)}
									className="w-full"
								/>
								<AntButton
									onClick={() => uploadImg(index)}
									loading={image.imgLoading}
									className="h-10 w-full  sm:w-[150px] rounded-lg bg-[#0A4D68] text-white"
								>
									Загрузить
								</AntButton>
								{image.path && (
									<AntButton
										onClick={() => viewImage(index)}
										className="h-10 w-full  sm:w-[100px] rounded-lg bg-[#0A4D68] text-white"
									>
										Скачать
									</AntButton>
								)}
								{index !== 0 && (
									<AntButton
										onClick={() => deleteRow(index)}
										className="h-10 w-full sm:w-[100px] rounded-lg p-2 bg-red-500 text-white"
									>
										Удалить
									</AntButton>
								)}

								{index === imageList.length - 1 && (
									<AntButton
										onClick={addNewRow}
										className="h-10 w-full  sm:w-[100px] rounded-lg bg-[#0A4D68] text-white"
									>
										Добавить
									</AntButton>
								)}
							</div>
						</div>
					))}
				</div>

				<div className="flex items-center justify-between gap-5 flex-col sm:flex-row w-full">
					<AntButton
						loading={isClientCreating}
						className="h-10 bg-red-500 text-white py-2 px-4 rounded-md w-full sm:w-[100px]"
						onClick={() => {
							onClose()
							resetForm()
							setCardCode('')
							setComment2('')
							setPhoneNumberArray([''])
							setIsOpenModal(false)
							setIsOpenModal(false)
						}}
					>
						Нет
					</AntButton>

					<AntButton
						loading={isClientCreating}
						className={
							'h-10 bg-[#0A4D68] text-white py-2 px-4 rounded-md w-full sm:w-[100px]'
						}
						disabled={
							!userName ||
							!userSureName ||
							!userFathersName ||
							!male ||
							!cardCode ||
							addresses.some(
								(address) => !address.U_RegionCode || !address.U_CityCode,
							) ||
							doesUserExist
						}
						onClick={createUserF}
					>
						Да
					</AntButton>
				</div>
			</div>
			<ErrorModal getRef={(r) => (errorModalRef.current = r)} />
		</Modal>
	)
}

export default CreateUser
